import React, { memo } from "react";
import ReusableAccordian from "../ReusableAccordion";
import { magnets } from "./defaults";
import Choices from "../Choices";
import { Image, Transformation } from "cloudinary-react";
import findImages from "./findImages";
import {
  Typography,
  Select,
  MenuItem,
  Alert,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import useMagnetSelector from "./useMagnetSelector";

function PivotMagnetAccordian() {
  const {
    pivotHardware,
    pivotMagnet,
    pivotAction,
    pivotMagnetColor,
    handleClick,
    handleChange,
  } = useMagnetSelector();

  return (
    <ReusableAccordian
      accordionName="pivotMagnet"
      heading="Magnet Catch"
      secondaryHeading="Select Magnet Catch"
      colOrRow="col"
    >
      {pivotHardware === "Fritsjurgens" && pivotAction === "Self Closing" ? (
        <Alert severity="error">
          Ghostop Magnet not available with Fritsjurgens Self Closing hardware
        </Alert>
      ) : (
        <>
          <RowLayout style={{ paddingBottom: 20 }}>
            <InfoIcon color="primary" style={{ marginRight: 10 }} />

            <Typography>
              The Ghostop magnet is embedded in the finished floor, assisting in
              keeping the door open.
            </Typography>
          </RowLayout>

          <RowLayout>
            {magnets.map((state) => (
              <div key={state.id} onClick={() => handleClick(state.label)}>
                <Choices
                  label={state.label}
                  variant={state.label === pivotMagnet ? "filled" : "outlined"}
                  checkMark={state.label === pivotMagnet}
                  wide={true}
                />
              </div>
            ))}
          </RowLayout>

          {pivotMagnet && (
            <RowLayout style={{ paddingTop: 20 }}>
              <ColLayout style={{ marginRight: 20 }}>
                <Typography style={{ fontWeight: "bold" }}>
                  Magnet Finish{" "}
                  <span
                    style={{ color: "red", fontWeight: "bold", fontSize: 22 }}
                  >
                    *
                  </span>
                </Typography>

                <Select
                  onChange={handleChange}
                  value={pivotMagnetColor}
                  style={{ minWidth: 150 }}
                  size="small"
                >
                  <MenuItem value="" />
                  <MenuItem value="Stainless Steel">Stainless Steel</MenuItem>
                  <MenuItem value="Black">Black</MenuItem>
                </Select>
              </ColLayout>

              <Image
                cloudName="ag-millworks"
                secure="true"
                publicId={findImages(pivotMagnetColor || "")}
                style={{ paddingLeft: 20 }}
              >
                <Transformation width="200" crop="scale" />
              </Image>

              <Image
                cloudName="ag-millworks"
                secure="true"
                publicId="PivotHardware/ghostop_floor"
                style={{ paddingLeft: 20 }}
              >
                <Transformation width="200" crop="scale" />
              </Image>
            </RowLayout>
          )}
        </>
      )}
    </ReusableAccordian>
  );
}

export default memo(PivotMagnetAccordian);
